import EditBoardContainer from "../containers/EditBoardContainer";

const EditBoardPage = () => {
  return (
    <EditBoardContainer />
  );
};

export default EditBoardPage;
